import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const settingsAPI = axios.create({
  baseURL: `${API_BASE}/api/settings`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Contact API functions
export const submitContactRequest = async (authToken, contactData) => {
  return settingsAPI.post("/contact", contactData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
  });
};

export const getContactRequests = async (authToken, limit = 50, offset = 0) => {
  return settingsAPI.get(`/contact?limit=${limit}&offset=${offset}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Feedback API functions
export const submitFeedback = async (authToken, feedbackData) => {
  return settingsAPI.post("/feedback", feedbackData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
  });
};

export const getFeedback = async (authToken, limit = 50, offset = 0) => {
  return settingsAPI.get(`/feedback?limit=${limit}&offset=${offset}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default settingsAPI;
